import React from 'react';
import { TableRow, TableHeader } from '@unimed-fesp/components';

const TableBeneficiarioHeader = () => {
  return (
    <TableRow>
      <TableHeader minWidth={40} maxWidth={40} />
      <TableHeader minWidth={260} maxWidth={260}>
        Nome
      </TableHeader>
      <TableHeader minWidth={120} maxWidth={120}>
        CPF
      </TableHeader>
      <TableHeader minWidth={70} maxWidth={70}>
        Código
      </TableHeader>
      <TableHeader minWidth={140} maxWidth={140}>
        Carteira
      </TableHeader>
      <TableHeader minWidth={100} maxWidth={100}>
        Dt. Nascimento
      </TableHeader>
    </TableRow>
  );
};

export default TableBeneficiarioHeader;
